import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import {
  AppBar, Toolbar, Button, Box, Typography, IconButton,
  Drawer, List, ListItem, ListItemButton, ListItemText, useMediaQuery
} from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import CloseIcon from '@mui/icons-material/Close';
import LoginIcon from '@mui/icons-material/Login';

const LayoutLandingHeader = () => {
  const isMobile = useMediaQuery('(max-width:600px)');
  const [drawerOpen, setDrawerOpen] = useState(false);

  const menuLinks = [
    { label: 'Home', to: '/' },
    { label: 'About US', to: '/AboutUS' },
    { label: 'Contact US', to: '/ContactUS' },
    { label: 'Login', to: '/Login' }
  ];

  const toggleDrawer = (open) => () => {
    setDrawerOpen(open);
  };

  return (
    <>
      <AppBar
        position="sticky"
        sx={{
          backgroundColor: '#ffffff',
          boxShadow: '0 2px 10px rgba(0,0,0,0.08)',
          px: 2,
        }}
      >
        <Toolbar sx={{ display: 'flex', justifyContent: 'space-between' }}>
          <Typography
            variant="h6"
            component={Link}
            to="/"
            sx={{
              textDecoration: 'none',
              color: '#004080',
              fontWeight: 'bold',
              fontSize: '1.8rem',
              fontFamily: "'Poppins', sans-serif",
              letterSpacing: '0.5px',
            }}
          >
            EASUP
          </Typography>

          {!isMobile ? (
            <Box sx={{ display: 'flex', alignItems: 'center' }}>
              {menuLinks.map((item, index) => {
                const isLogin = item.label === 'Login';
                return (
                  <Button
                    key={index}
                    component={Link}
                    to={item.to}
                    sx={{
                      color: isLogin ? '#ffffff' : '#333333',
                      backgroundColor: isLogin ? '#004080' : 'transparent',
                      fontWeight: isLogin ? 'bold' : 500,
                      fontSize: '1rem',
                      fontFamily: "'Poppins', sans-serif",
                      textTransform: 'none',
                      mx: 1.5,
                      borderRadius: isLogin ? '20px' : '0',
                      px: isLogin ? 2 : undefined,
                      py: isLogin ? 1 : undefined,
                      '&:hover': {
                        color: isLogin ? '#ffffff' : '#004080',
                        backgroundColor: isLogin ? '#003366' : 'transparent',
                      },
                      display: 'flex',
                      alignItems: 'center',
                      gap: isLogin ? 1 : 0,
                    }}
                  >
                    {isLogin && <LoginIcon sx={{ fontSize: '18px' }} />}
                    {item.label}
                  </Button>
                );
              })}
            </Box>
          ) : (
            <>
              <IconButton onClick={toggleDrawer(true)} edge="end">
                <MenuIcon sx={{ color: '#004080' }} />
              </IconButton>
              <Drawer anchor="right" open={drawerOpen} onClose={toggleDrawer(false)}>
                <Box sx={{ width: 250, p: 2 }}>
                  <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 2 }}>
                    <Typography variant="h6" sx={{ color: '#004080' }}>
                      Menu
                    </Typography>
                    <IconButton onClick={toggleDrawer(false)}>
                      <CloseIcon />
                    </IconButton>
                  </Box>
                  <List>
                    {menuLinks.map((item, index) => (
                      <ListItem key={index} disablePadding>
                        <ListItemButton
                          component={Link}
                          to={item.to}
                          onClick={toggleDrawer(false)}
                        >
                          <ListItemText
                            primary={
                              item.label === 'Login' ? (
                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                  <LoginIcon sx={{ fontSize: '18px', color: '#004080' }} />
                                  {item.label}
                                </Box>
                              ) : (
                                item.label
                              )
                            }
                          />
                        </ListItemButton>
                      </ListItem>
                    ))}
                  </List>
                </Box>
              </Drawer>
            </>
          )}
        </Toolbar>
      </AppBar>
    </>
  );
};

export default LayoutLandingHeader;
